/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  Integration,
  List,
  SpaceIntegrationBlocks,
} from "./data-contracts";

/**
 * @description Returns a paginated list of integrations that are currently installed and enabled on the space. Use the query parameter to filter by integration name. Use this to check which integrations are active before interacting with integration-specific features or blocks.
 * @tags space-integrations
 * @name ListSpaceIntegrations
 * @summary List all third-party integrations enabled on a space
 * @request GET:/spaces/{spaceId}/integrations
 * @secure
 */

// @ts-ignore
export const listSpaceIntegrations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** A search string to filter integrations by name */
    search?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Integration[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/integrations",
  method: "get",
  streaming: false,
  tags: ["space-integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns all custom block types contributed by integrations installed on the space. Integration blocks are custom content elements (e.g. embedded widgets, code runners) that integrations register for use in pages. Use this to discover what custom block types are available in a given space.
 * @tags space-integrations
 * @name ListSpaceIntegrationsBlocks
 * @summary List all custom content blocks provided by integrations in a space
 * @request GET:/spaces/{spaceId}/integration-blocks
 * @secure
 */

// @ts-ignore
export const listSpaceIntegrationsBlocks: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SpaceIntegrationBlocks;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/integration-blocks",
  method: "get",
  streaming: false,
  tags: ["space-integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
